import { render, staticRenderFns } from "./FormAnswer.vue?vue&type=template&id=fce10dec&scoped=true&"
import script from "./FormAnswer.vue?vue&type=script&lang=js&"
export * from "./FormAnswer.vue?vue&type=script&lang=js&"
import style0 from "./FormAnswer.vue?vue&type=style&index=0&id=fce10dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fce10dec",
  null
  
)

export default component.exports